import React from 'react';

import {colors} from 'js-libs/sweetcommons/styles';
import styled from 'styled-components';

import {cannotHoverAndCanTouch} from 'app/utils/browser';

interface Props {
  children: (showTooltip: boolean, hideTooltip: () => void) => React.ReactNode;
  innerContent: React.ReactNode;
}

export function PageSidebarStructure({
  children,
  innerContent,
}: Props): JSX.Element {
  const [helpIsActive, setHelpActive] = React.useState(false);
  const toggleHelp = () => setHelpActive((active) => !active);
  const hideHelp = () => (helpIsActive ? setHelpActive(false) : null);
  return (
    <StyledContainerDIV>
      <StyledInnerContainerDiv>
        <StyledIconsDIV>{children(helpIsActive, hideHelp)}</StyledIconsDIV>
        {cannotHoverAndCanTouch ? (
          <StyledHelpButton
            onClick={toggleHelp}
            className={`${helpIsActive ? 'active' : ''}`}
          >
            <i className="fa fa-question-circle" />
          </StyledHelpButton>
        ) : null}
      </StyledInnerContainerDiv>
      <StyledInnerListDIV>{innerContent}</StyledInnerListDIV>
    </StyledContainerDIV>
  );
}

const StyledContainerDIV = styled.div`
  display: flex;
  height: 100%;
  box-shadow: 1px 0 5px rgba(0, 0, 0, 0.1);
`;
const StyledInnerContainerDiv = styled.div.attrs({
  className: 'd-flex flex-column justify-content-between d-print-none',
})`
  overflow: auto;
  border-top: 1px solid ${colors.borderGray};
  -webkit-overflow-scrolling: touch;

  ::-webkit-scrollbar {
    @media (min-height: 650px) {
      width: 0;
    }
  }
`;
const StyledIconsDIV = styled.div.attrs({
  className: 'list-group',
})`
  flex: 0 0 auto;
  background-color: #fff;
  border-left: none;
  border-right: none;

  .list-group-item {
    border-radius: 0;
    text-align: center;
    border-left: none;
    border-right: none;
    border-top: none;
  }
`;
const StyledInnerListDIV = styled.div`
  border-left: 1px solid ${colors.borderGray};
  width: 250px;

  &:empty {
    display: none;
  }
`;
const StyledHelpButton = styled.button.attrs<{className?: string}>({
  className: 'btn btn-link',
})`
  transition: all 0.25s;
  opacity: 0.5;

  &.active {
    opacity: 0.8;
  }
`;
